import React from 'react'
import _ from 'lodash'

import {Row, Col} from 'react-flexbox-grid'

import {Button, Icon, Modal} from 'antd'

import {QueryService} from 'api/message'
import {NetworkService} from 'api/network'

import {SetupGuide} from './'
import {AddressEncoder} from 'ui'

const skipSetup = props => {
   let {network, router, routes} = props,
      newRoutes = _.slice(routes, 0, -1),
      nextPath = _.map(newRoutes, r => r.path)
         .slice(0, -1)
         .concat(['network', props.network.key, 'overview'])
         .join('/')
         .replace('//', '/')

   SetupGuide.skipSetup(network)

   router.push(nextPath)
}

const PortListExample = () => (
   <pre style={{padding: '9.5px', margin: '0 0 10px', fontSize: '13px'}}>
      <code>
         {'> guri-windows-amd64.exe -list'}
         <span style={{color: 'grey'}}>
            {`
path=COM0 usb?=false vid= pid= serial=
path=`}<b>COM3</b>{` usb?=true vid=0403 pid=6001 serial=A5042CXY
`}
         </span>
      </code>
   </pre>
)

const PortConnectExample = ({network}) => {
   const encodedNid = AddressEncoder.encode(network.address)

   return (
      <pre style={{padding: '9.5px', margin: '0 0 10px', fontSize: '13px'}}>
         <code>
            {`> guri-windows-amd64.exe -auto-configure -nid=${encodedNid}`}
            {' '}
            <b>COM3</b>
            <span style={{color: 'grey'}}>
               {`
guri - version 0.0.1-alpha
serial:open /dev/ttyUSB0
remote: using TCP w/TLS
upstream:recv[true] [10 0 0 0 0 0 3 16 0 0]
downstream:recv[true] [35 1 0 0 0 1 0 0 0 ... ]
upstream:recv[true] [6]
`}
            </span>
         </code>
      </pre>
   )
}

export const ConnectionInner = ({network, ...props}) => {
   const encodedNid = AddressEncoder.encode(network.address)
   const connectorDocs = '#/docs/reference-guide/network-connector/index.html'

   return (
      <Row style={{marginTop: '3rem', position: 'relative'}}>
         <Col md={12}>
            <div className="page-header">
               <h4>Connect Gateway</h4>
            </div>

            <Row>
               <Col xs={9}>
                  <p style={{marginBottom: '1em'}}>
                     The final step you will connect your Tinymesh Gateway to a serial port
                     on your machine. We will use GURI, a transparent
                     {' '}
                     <a href={connectorDocs}>Network Connector</a>
                     {' '}
                     to communicate serial port data between
                     the Tinymesh Gateway and the Tinymesh Cloud.
                  </p>
                  <p style={{marginBottom: '1em'}}>
                     GURI is a Command Line program and you will need to use
                     {' '}
                     <code>cmd.exe</code>
                     {' '}
                     to run it. Once downloaded you must run it every time you
                     wish to connect your Tinymesh Gateway to the Tinymesh Cloud.
                  </p>
                  <p style={{marginBottom: '1em'}}>
                     To continue downloaded GURI and store it somewhere on your computer.
                  </p>
               </Col>
               <Col xs={3} style={{padding: '15px 15'}}>
                  <a
                     href="https://release.tiny-mesh.com/"
                     target="new"
                     className="ant-btn ant-btn-primary ant-btn-lg"
                  >

                     <Icon type="download" /> Download GURI
                  </a>
               </Col>
            </Row>

            <hr style={{margin: '1em 0 2em'}} />

            <Row style={{marginBottom: '1em'}}>
               <Col xs={12}>
                  <p style={{marginBottom: '1em'}}>
                     <b>List serialports</b> using the <code>-list</code> argument,
                     in the example below we are using <code>COM3</code>.
                  </p>

                  <p style={{marginBottom: '1em'}}>
                     The response will be a list of serial ports available on
                     your computer. If you are unsure which serial port is your
                     gateway run the <code>--list</code> command once without the
                     USB gateway connected and then once with the gateway connected.
                     Compare the results and new line from the second run will be
                     your gateway.
                  </p>

                  <PortListExample />
               </Col>
            </Row>

            <Row style={{marginBottom: '1em'}}>
               <Col xs={12}>
                  <p>
                     <b>Open the serial port</b> by giving giving the serial port name
                     from the last step. The argument <code>-auto-configure</code>{' '}
                     automatically configures the device as a Gateway.
                     Your network id (<code>{encodedNid}</code>) is specified
                     by using <code>-nid={encodedNid}</code>.
                  </p>

                  <PortConnectExample network={network} />
               </Col>
            </Row>

            <hr style={{margin: '1em 0 2em'}} />

            <Row>
               <Col xs={12}>
                  <p>
                     Once you have completed the steps, refresh the page.
                     &nbsp;
                     <Button
                        icon="close"
                        type="primary"
                        onClick={() => skipSetup({network, ...props})}
                        className="pull-right"
                     >
                        Skip guide
                     </Button>
                  </p>
               </Col>
            </Row>
         </Col>
      </Row>
   )
}

ConnectionInner.propTypes = {
   network: React.PropTypes.object.isRequired,
   router:  React.PropTypes.object.isRequired,
   routes:  React.PropTypes.array.isRequired
}

PortConnectExample.propTypes = {
   network: React.PropTypes.object.isRequired
}

ConnectionInner.opts = opts => opts

export class Connection extends React.Component {
   static get propTypes() {
      return {
         network: React.PropTypes.object,
         router:  React.PropTypes.object.isRequired,
         routes:  React.PropTypes.array.isRequired
      }
   }
   constructor() {
      super()

      this.state = {
         gotoModal: null
      }

      this.onMessage = this.onMessage.bind(this)
      this.openGotoModal = this.openGotoModal.bind(this)
   }

   componentWillMount() {
      const {network} = this.props

      this._mounted = false

      setTimeout(() => {
         QueryService.stream(
            network.key,
            {'date.from': network.meta.created, query: 'proto/tm.detail == "nid"'},
            this.onMessage,
            false
         )
            // got headers
            .then(({xhr}) => {
               this._queryStream = xhr
            })
            .catch(err => {
               console.log('stream closed, restarting in 2500ms', err)
               this._queryStream = null
               setTimeout(this.openStream, 2500)
            })
      }, 0)
   }

   componentWillUnmount() {
      this._mounted = false

      if (this._queryStream) {
         this._queryStream.abort()
      }
   }

   openGotoModal(nid) {
      const okTxt = 'You are now connected, go to the Network overview to start using your network'

      if (null === this.state.gotoModal) {
         let gotoModal = Modal.confirm({
            title:      'You\'r connected!',
            content:    okTxt,
            okText:     'Go to Overview',
            cancelText: 'Cancel',
            onOk:       cb => {
               cb()
               this.setState({gotoModal: null}, () =>
                  this.props.router.push(`/dashboard/network/${nid}/overview`)
               )
            }
         })

         this.setState({gotoModal})
      }
   }

   onMessage(_msg) {
      const {network} = this.props,
         errTxt = 'An unexpected error occured when re-loading the network. Try refreshing the page'

      NetworkService.fetch(network.key)
         .then(() => {
            this.openGotoModal(network.key)
         })
         .catch(_err => {
            Modal.error({
               title:   'Failed to fetch network',
               content: errTxt
            })
         })
   }

   render() {
      const {network, routes, router} = this.props

      return <ConnectionInner network={network} routes={routes} router={router} />
   }
}

/*
<Col md={6}>
   <p style={{marginTop: '110px', marginBottom: '2rem'}}>
      Tinymesh Network uses a Network Connector to communicate
      between your physial Gateway Device and the Tinymesh Cloud.
   </p>
</Col>
*/



// WEBPACK FOOTER //
// lib/bundle/dashboard/setup-guide/Connection.jsx